import script from "./HelpdeskSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./HelpdeskSidebar.vue?vue&type=script&setup=true&lang=js"

import "./HelpdeskSidebar.vue?vue&type=style&index=0&id=28047c3a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-28047c3a"]])

export default __exports__